module.exports = __webpack_public_path__ + "0ff6411a69c147f55ad1739666d33474.png";